import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'shalala';
import { Col, Row } from 'react-bootstrap';

import { useStore } from '../../store';
import Loading from '../../facturotopia/loading/Loading';
import PageHeader from '../../support/page-header/PageHeader';
import ClientesConsumoInfo from './components/ClientesConsumoInfo';
import ClientesPacsConsumoInfo from './components/ClientesPacsConsumoInfo';
import DashboardClientesFilters from './components/DashboardClientesFilters';
import DoughnutChartHitsSummary from './components/DoughnutChartHitsSummary';
import DoughnutChartPacsSummary from './components/DoughnutChartPacsSummary';
import MonthlyHitsUsage from '../../app/dashboard/components/MonthlyHitsUsage';

class DashboardClientesInfo extends Component {
  componentDidMount() {
    const { id } = this.props.match.params;

    this.props.summary(id, {
      from: moment().subtract(2, 'months').toDate(),
      to: moment().toDate(),
    });
  }

  render() {
    const { busy, data, cliente } = this.props;

    const { labels = [], data: values = [], total = [], pacs = [] } = data;

    return (
      <>
        <PageHeader
          text="Dashboard"
          to="/admin/dashboard"
        />

        <Row className="mt-3">
          <Col
            sm="auto"
            md="12"
            className="mb-2"
          >
            <DashboardClientesFilters cliente={cliente} />
          </Col>
        </Row>

        {!!busy && <Loading className="ml-3 mt-3 text-info" />}

        <Row className="mt-3">
          <Col
            xs={12}
            sm={12}
            md={5}
            lg={5}
          >
            <div className="d-block mt-3 mb-2">
              <strong className="text-muted">Detalles</strong>
            </div>

            <ClientesConsumoInfo
              total={total}
              cliente={cliente}
            />
          </Col>

          <Col
            xs={12}
            sm={12}
            md={7}
            lg={7}
          >
            <DoughnutChartHitsSummary total={total} />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col
            xs={12}
            sm={12}
            md={5}
            lg={5}
          >
            <div className="d-block mt-3 mb-2">
              <strong className="text-muted">Pacs</strong>
            </div>

            <ClientesPacsConsumoInfo
              pacs={pacs}
              cliente={cliente}
            />
          </Col>

          <Col
            xs={12}
            sm={12}
            md={7}
            lg={7}
          >
            <DoughnutChartPacsSummary pacs={pacs} />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <MonthlyHitsUsage
              labels={labels}
              data={values}
            />
          </Col>
        </Row>
      </>
    );
  }
}

const mapState = (store) => {
  return store.reporte_consumo.info;
};

const mapActions = (actions) => {
  return {
    summary: actions.reporte_consumo.info.summary,
  };
};

export default connect(useStore, mapState, mapActions)(DashboardClientesInfo);
